import { render } from "./Element.vue?vue&type=template&id=4b58e722&scoped=true"
import script from "./Element.vue?vue&type=script&lang=js"
export * from "./Element.vue?vue&type=script&lang=js"

import "./Element.vue?vue&type=style&index=0&id=4b58e722&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b58e722"]])

export default __exports__